export { TdHighlightComponent } from './highlight.component';
export { CovalentHighlightModule } from './highlight.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/highlight/index.js
// module id = ../../../../@covalent/highlight/index.js
// module chunks = 4